"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/ng2-filter.module"));
__export(require("./src/ng2-filter.pipe"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/ng2-search-filter/dist/index.js
// module id = ../../../../ng2-search-filter/dist/index.js
// module chunks = 5